import { render, staticRenderFns } from "./jenislantai.vue?vue&type=template&id=206f1486"
import script from "./jenislantai.vue?vue&type=script&lang=js"
export * from "./jenislantai.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports